import {
    destructiveButtonTheme,
    ghostButtonTheme,
    primaryButtonTheme,
    secondaryButtonTheme,
    specialButtonTheme,
    tertiaryButtonTheme,
} from './shared';
import { colors } from './themeCore';

const feature = {
    account: colors.gold400,
    person: colors.seafoam300,
    client: colors.purple300,
};

const intent = {
    negative: colors.red300,
    neutral: colors.cocoa700,
    positive: colors.green500,
    warn: colors.gold100,
    info: colors.seafoam500,
    disabled: colors.cocoa100,
};

const border = {
    light: colors.cocoa100,
    dark: colors.cocoa300,
    separator: colors.cocoa700,
    highlight: colors.green200,
    active: colors.seafoam400,
};

const nav = {
    primaryBackground: colors.gray2,
    highlightBackground: colors.gray1,
    logoColor: colors.brownishTan,
};

const container = {
    primaryBackground: colors.gray0,
    secondaryBackground: colors.cocoa0,
    errorBackground: colors.red0,
    highlightBackground: `${colors.green0}33`,
    activeBackground: colors.seafoam0,
    backdrop: `${colors.cocoa950}88`,
};

const buttons = {
    special: specialButtonTheme,
    primary: primaryButtonTheme,
    secondary: secondaryButtonTheme,
    tertiary: tertiaryButtonTheme,
    ghost: ghostButtonTheme,
    destructive: destructiveButtonTheme,
};

const text = {
    primary: colors.cocoa900,
    subtle: colors.cocoa600,
    disabled: colors.cocoa400,
    positive: intent.positive,
    negative: intent.negative,
    white: colors.gray0,
    highlight: colors.gold400,
    link: colors.blue600,
    linkHighlight: colors.blue800,
};

export const defaultLight = {
    feature,
    intent,
    border,
    container,
    buttons,
    text,
    nav,
};

export const defaultDark = defaultLight;
